// @ts-strict-ignore
import React from 'react'
import PageHeader from 'scenes/Landing/components/PageHeader'
import { useDebouncedEffect } from 'hooks/debounce'
import { useWindowSize } from 'hooks/useWindowSize'
import { optimizeSrc } from 'services/filestack'
import useStyles from './styles'

export interface ILandingHeaderProps {
  children?: React.ReactNode
  backgroundImage?: string
  wide?: boolean
  compact?: boolean
  style?: React.CSSProperties
  className?: string
}

export default function LandingHeader(props: ILandingHeaderProps) {
  const { children, backgroundImage, wide, compact, className } = props
  const { classes } = useStyles()
  const { innerWidth } = useWindowSize()
  const [innerWidthActual, setInnerWidthActual] = React.useState(innerWidth)

  useDebouncedEffect(() => {
    setInnerWidthActual(innerWidth)
  }, 200, [innerWidth])

  return (
    <PageHeader backgroundImage={optimizeSrc(backgroundImage, { width: innerWidthActual })} wide={wide} compact={compact} className={className}>
      <div className={classes.content}>
        {children}
      </div>
    </PageHeader>
  )
}
